import useFileSaver from "@hooks/useFileSaver";
import useRequest, { IDataRequest } from "@hooks/useRequest";
import React from "react";

export interface IFaturaFilter {
    competencia: string
}


const controller = '/Relatorio/Fatura';

export function useRelatorioFaturaService () {
    const _request = useRequest();
    const fileSaver = useFileSaver();

    const listar = React.useCallback((request: IDataRequest<IFaturaFilter>) => {
        return _request.getData(`${controller}/Listar`, request);
    }, [_request]);
    
    const exportar = React.useCallback((request: IDataRequest<IFaturaFilter>) => {
        return _request.download(`${controller}/Exportar`, {
            params: request
        })
            .then(response => { 
                fileSaver.save(response, `Novos-Inadimplentes.csv`);
            });
    }, [_request, fileSaver]);
    
    return React.useMemo(() => ({
        listar, exportar
    }), [exportar, listar]);
}
